module.exports = __webpack_public_path__ + "cedf13d86212fd8cebdb8c879a878529.svg";